import React, { useState, useEffect } from 'react'
import './Toggle.css'

export default function Toggle(props) {
    const [toggleValue, setToggleValue] = useState(props.initialState || 'off')
    const checkBoxHandler = (event) => {
        if(toggleValue === 'off'){
            setToggleValue("on")
        } else {
            setToggleValue("off")
        }
    }
    const {onInput, id} = props

    useEffect(() => {
        onInput(id, toggleValue, true)
    }, [onInput, toggleValue, id]);

    return (
        <div className="toggle">
            <label className="toggle-label">{props.label}</label>
            <label className="switch">
            <input className="toggle-check" type="checkbox" onChange={checkBoxHandler}/>
                <span className="slider round" 
                style={toggleValue === "on" ? {backgroundColor:"rgb(107,172,228)"} : {backgroundColor:"#ccc"}}></span>
            </label>
        </div>
    )
}
